// extracted by css-extract-rspack-plugin
export default {"cls1":"BlurredHiddenThumbs-cls1_eYC","cls2":"BlurredHiddenThumbs-cls2_J6M BlurredHiddenThumbs-cls1_eYC"};